





























































import * as I from '@/interfaces';
import * as E from '@/enums';
import { Vue, Component, Prop, Emit, Ref } from 'vue-property-decorator';
import AxMonitorContext from './AxMonitorContext.vue';

class State {
  isEnter: boolean; //출입이벤트가들어왔을경우
  isConnected: boolean;
  dataOne: string;
  dataTwo: string;
  doorStatus: number;
  isDrag: boolean;
  isZoom: boolean;
  prevX: number;
  prevY: number;
  startX: number;
  startY: number;
  marginLeft: number;
  marginTop: number;
  width: number;
  height: number;
  photo: BinaryType[];
  constructor() {
    this.isEnter = true;
    this.isConnected = false;
    this.dataOne = '';
    this.dataTwo = '';
    this.doorStatus = 0;
    this.isDrag = false;
    this.isZoom = false;
    this.prevX = 0;
    this.prevY = 0;
    this.startX = 0;
    this.startY = 0;
    this.marginLeft = 0;
    this.marginTop = 0;
    this.width = 50;
    this.height = 50;
    this.photo = [];
  }
  get isFire() {
    if (this.doorStatus === 160) {
      return true;
    } else {
      return false;
    }
  }

  get isAdminOpen() {
    if (this.doorStatus === 131 || this.doorStatus === 150) {
      return true;
    } else {
      return false;
    }
  }

  get isAdminClose() {
    if (this.doorStatus === 161 || this.doorStatus === 133 || this.doorStatus === 152) {
      return true;
    } else {
      return false;
    }
  }

  get isSchedule() {
    if (this.doorStatus === 150 || this.doorStatus === 152) {
      return true;
    } else {
      return false;
    }
  }

  get isError() {
    if (this.doorStatus >= E.EDeviceEventCode.AUTH_ERR_UNREGISTERED_MEDIA) {
      return true;
    } else {
      return false;
    }
  }
}

@Component
export default class AxMonitorElement extends Vue {
  state: State = new State();
  @Prop()
  door!: I.MonitorDoor;
  @Prop()
  sensor!: I.MonitorSensor;
  @Ref()
  context!: AxMonitorContext;

  oldDoorStatus = 0;
  newDoorStatus = 0;

  AddEvent(event: I.MonitorSimpleEvent) {
    console.log('eventcode' + event.eventCode);
    console.log('photo', event.photo);
    this.state.doorStatus = event.eventCode;
    this.state.photo = event.photo;
  }

  onDoorControl(doorid: number, controlcode: number) {
    console.log('onDoorControl' + doorid);
    this.$emit('onOpenClick', doorid, controlcode);
  }

  BottomClick(e: MouseEvent) {
    this.$emit('onDoorClick', this.door);
  }

  get name() {
    if (this.door) return this.door.name;
    else if (this.sensor) return this.sensor.name;
    else return '';
  }

  get id() {
    if (this.door) return this.door.doorID;
    else if (this.sensor) return this.sensor.sensorID;
    else return '';
  }

  get marginLeft() {
    if (this.door) return this.door.locationX;
    else if (this.sensor) return this.sensor.locationX;
    else return 0;
  }

  get marginTop() {
    if (this.door) return this.door.locationY;
    else if (this.sensor) return this.sensor.locationY;
    else return 0;
  }

  MouseDown(e: MouseEvent) {
    // if (!this.state.isEditMode) return;
    e.preventDefault();
    if (e.button === 0) {
      //왼클릭
      this.state.prevX = e.pageX;
      this.state.prevY = e.pageY;
      this.state.startX = e.pageX;
      this.state.startY = e.pageY;
      this.state.isDrag = true;
    }
  }
  MouseLeave(e: MouseEvent) {
    this.state.isDrag = false;
    console.log(e);
  }
  MouseUp(e: MouseEvent) {
    this.state.isDrag = false;
    e.preventDefault();
    this.door.locationX = this.state.marginLeft;
    this.door.locationY = this.state.marginTop;
    this.$emit('onDoorUpdate', this.door);
  }
  MouseMove(e: MouseEvent) {
    if (!this.state.isDrag) return;
    const y = e.pageY - this.state.prevY;
    const x = e.pageX - this.state.prevX;
    this.state.prevX = e.pageX;
    this.state.prevY = e.pageY;
    this.state.marginLeft += x;
    this.state.marginTop += y;
  }

  Photo(photo: BinaryType[]) {
    console.log('img:', photo);
    if (photo == null) {
      return require('../../assets/user/user_empty.png');
    } else if (photo.length > 0) {
      return 'data:image/png;base64, ' + photo;
    } else {
      return require('../../assets/user/user_empty.png');
    }
  }

  get doorClass() {
    if (!this.state.isConnected) return 'disconnected';

    switch (this.state.doorStatus) {
      case 0: //기본
      case 104: //닫힘
      case 161: //화제 폐쇄
      case 102: //열림
      case 160: //화재 개방
      case 103: //계속 열림
      case 105: //강제로 열림
      case 106: //강제로 계속 열림
        this.oldDoorStatus = this.state.doorStatus;
        this.newDoorStatus = this.state.doorStatus;
        break;
      default:
        this.newDoorStatus = this.oldDoorStatus;
    }
    switch (this.newDoorStatus) {
      case 0: //기본
      case 104: //닫힘
      case 161: //화제 폐쇄
        return 'close';
        break;
      case 102: //열림
      case 160: //화재 개방
        return 'open';
        break;
      case 103: //계속 열림
        return 'open-keep';
        break;
      case 105: //강제로 열림
        return 'open-force';
        break;
      case 106: //강제로 계속 열림
        return 'open-keep-force';
        break;
    }
  }
  Resize(width: number, height: number) {
    if (this.door) {
      //this.state.marginLeft = this.door.locationX * (width / this.door.baseWidth);
      //this.state.marginTop = this.door.locationY * (height / this.door.baseHeight);
      this.state.marginLeft = this.door.locationX;
      this.state.marginTop = this.door.locationY;
      // this.width = this.element.width * (width / this.element.baseWidth);//화면 크기 변경 되었을 때 문 이미지 사이즈도 조정 할 경우 주석 해제
      // this.height = this.element.height * (height / this.element.baseHeight);//화면 크기 변경 되었을 때 문 이미지 사이즈도 조정 할 경우 주석 해제
    } else if (this.sensor) {
      this.state.marginLeft = this.sensor.locationX * (width / this.sensor.baseWidth);
      this.state.marginTop = this.sensor.locationY * (height / this.sensor.baseHeight);
      // this.width = this.element.width * (width / this.element.baseWidth);//화면 크기 변경 되었을 때 문 이미지 사이즈도 조정 할 경우 주석 해제
      // this.height = this.element.height * (height / this.element.baseHeight);//화면 크기 변경 되었을 때 문 이미지 사이즈도 조정 할 경우 주석 해제
    }
  }
}
